"use client";

import { useI18n } from "@llmgateway/i18n/react";

export function TestimonialsHeading() {
	const { t } = useI18n();

	return (
		<div className="mx-auto max-w-7xl px-6 lg:px-8 mb-16">
			<p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-4">
				{t("landing.testimonials.eyebrow")}
			</p>
			<h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-foreground">
				{t("landing.testimonials.title")}
			</h2>
		</div>
	);
}
